export default "__VITE_ASSET__zq0fjz7___"